import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

/**
 * Beschriftung mit Erklär-Tooltip für ein einzelnes Formularfeld
 * (KONVENTIONEN.md Abschnitt 4/5: "Erklär-Tooltip an jedem Element") - so
 * trägt jedes Kopf-/Positionsfeld seine Erklärung, ohne sie an jeder
 * Aufrufstelle einzeln mit OverlayTrigger zu umschließen.
 */
export default function FeldMitHilfe({label, help, id, className = "mb-2", children}) {
    return (
        <div className={className}>
            <OverlayTrigger placement="top" overlay={<Tooltip id={`${id}-tip`}>{help}</Tooltip>}>
                <label htmlFor={id} className="form-label small fw-semibold mb-1 d-inline-block">
                    {label}
                </label>
            </OverlayTrigger>
            {children}
        </div>
    );
}
